import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";

export const GENERATE_UPLOAD_URL = gql`
  mutation GenerateUploadURL($input: GenerateUploadURLInput!) {
    generateUploadURL(input: $input) {
      uploadURL
    }
  }
`;

interface GenerateUploadURLData {
  generateUploadURL: {
    uploadURL: string; // Recieved from the payload
  };
}

interface GenerateUploadURLVariables {
  input: {
    bucket: string;
  };
}

export const useUploadURL = () => {
  // Execute the mutation
  const [generateUploadURL, { error, loading }] = useMutation<
    GenerateUploadURLData,
    GenerateUploadURLVariables
  >(GENERATE_UPLOAD_URL);
  const getUploadURL = async (bucket: string): Promise<string> => {
    const result = await generateUploadURL({
      variables: { input: { bucket: bucket } },
    });

    // Check if result.data and result.data.generateUploadURL are defined
    if (result.data?.generateUploadURL.uploadURL) {
      const url: string = result.data.generateUploadURL.uploadURL;
      return url;
    } else {
      throw new Error("Ugyldig respons fra bildeopplastingen");
    }
  };
  return { getUploadURL, error, loading };
};
